<template>
  <header id="data-product-details-header" class="buying-zone__header small-12 medium-6 large-12 cell">
    <div class="buying-zone__flags">
      <product-badge-group
        :product="product"
        :base-properties="baseProperties"
        class="buying-zone__badge inline-block pr-0"
      />
      <span
        v-if="product.marketingModelYear && !product.isArchived"
        qaid="product-modelyear"
        class="buying-zone__model-year text-md"
        v-html="product.marketingModelYear"
      >
      </span>
      <span
        v-if="product.modelYearIntroAndCurrent && product.isArchived"
        qaid="product-modelyear-archived"
        class="buying-zone__model-year text-md"
        v-html="product.modelYearIntroAndCurrent"
      >
      </span>
    </div>
    <h1 qaid="product-name" class="buying-zone__title" v-html="product.name"></h1>
    <pdp-reviews-summary :product="product" />
    <span class="pr-separator"> / </span>
  </header>
</template>
<script>
import PdpReviewsSummary from '@/components/containers/pdp/PdpReviewsSummary';
import ProductBadgeGroup from '@/components/ProductBadgeGroup';

export default {
  name: 'PdpProductHeader',
  components: {ProductBadgeGroup, PdpReviewsSummary},
  props: {
    product: {
      type: Object,
      required: true,
    },
    variantCode: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>
